// Copyright ©️ 2026 eVolve MEP, LLC

export const CHECKMARK_PATH_TOKENS: (string | number)[] = [
  'M',
  5.7,
  12.025,
  'L',
  0,
  6.325,
  'L',
  1.425,
  4.9,
  'L',
  5.7,
  9.175,
  'L',
  14.875,
  0,
  'L',
  16.3,
  1.425,
  'Z',
];
